import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full self-stretch inline-flex flex-col justify-start items-start" }
const _hoisted_2 = {
  "data-qty-btn": "true",
  "data-style": "Multiple Btns",
  class: "w-full p-4 inline-flex justify-start items-center gap-6"
}
const _hoisted_3 = {
  key: 0,
  class: "flex w-[calc(100%_-_100px)] justify-center items-center"
}
const _hoisted_4 = {
  key: 1,
  class: "w-full h-screen overflow-y-auto pb-[200px]"
}
const _hoisted_5 = {
  key: 2,
  class: "w-full h-screen overflow-y-auto px-[16px] py-[8px]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block_loading = _resolveComponent("block-loading")!
  const _component_EachProfile = _resolveComponent("EachProfile")!
  const _component_NewProfile = _resolveComponent("NewProfile")!
  const _component_EditProfile = _resolveComponent("EditProfile")!
  const _component_Manage = _resolveComponent("Manage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-1 flex justify-start items-center gap-2" }, [
        _createElementVNode("div", { class: "flex-1 justify-center text-white text-xl font-bold font-['Roboto'] leading-6 tracking-tight" }, "Profiles")
      ], -1)),
      (_ctx.can_edit_business_brand_profiles)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showNewProfile && _ctx.showNewProfile(...args))),
            "data-fill-color": "Green",
            "data-fill": "Yes",
            "data-show-copy": "true",
            "data-show-icon-l": "true",
            "data-show-icon-r": "false",
            "data-type": "CTA",
            class: "h-11 px-4 py-2 bg-green-500 rounded-md flex justify-center items-center gap-2 overflow-hidden"
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "w-6 h-6 relative" }, [
              _createElementVNode("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z",
                  fill: "white"
                })
              ])
            ], -1),
            _createElementVNode("div", { class: "justify-center text-white text-sm font-medium font-['Roboto'] uppercase leading-4 tracking-widest" }, "New Profile", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_block_loading)
        ]))
      : (_ctx.branding && _ctx.branding.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branding, (profile, index) => {
              return (_openBlock(), _createBlock(_component_EachProfile, {
                key: index,
                brandingSize: _ctx.branding.length,
                branding: profile,
                businessName: profile.name,
                merchantWebsiteUrl: profile.domain,
                googleAnalyticsTrackingId: profile.googleAnalyticsKey,
                refetchAllLocationsKey: _ctx.refetchAllLocationsKey,
                onShowEditProfile: ($event: any) => (_ctx.showEditProfile(profile)),
                onShowManage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showManage($event))),
                onRemoved: _ctx.handleProfileRemoved
              }, null, 8, ["brandingSize", "branding", "businessName", "merchantWebsiteUrl", "googleAnalyticsTrackingId", "refetchAllLocationsKey", "onShowEditProfile", "onRemoved"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, "No profiles found")),
    (_ctx.newProfilePop)
      ? (_openBlock(), _createBlock(_component_NewProfile, {
          key: 3,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.newProfilePop=false)),
          onCreated: _ctx.handleProfileCreated
        }, null, 8, ["onCreated"]))
      : _createCommentVNode("", true),
    (_ctx.editProfilePop)
      ? (_openBlock(), _createBlock(_component_EditProfile, {
          key: 4,
          branding: _ctx.selectedProfile,
          businessName: _ctx.selectedProfile?.name,
          merchantWebsiteUrl: _ctx.selectedProfile?.domain,
          googleAnalyticsTrackingId: _ctx.selectedProfile?.googleAnalyticsKey,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editProfilePop=false)),
          onUpdated: _ctx.handleProfileUpdated
        }, null, 8, ["branding", "businessName", "merchantWebsiteUrl", "googleAnalyticsTrackingId", "onUpdated"]))
      : _createCommentVNode("", true),
    (_ctx.managePop)
      ? (_openBlock(), _createBlock(_component_Manage, {
          key: 5,
          profile: _ctx.selectedProfileForManage,
          onClose: _ctx.handleManageClose
        }, null, 8, ["profile", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}